/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_CrumbInputs */

const th_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรไฟล์`)
};

const en_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const ja_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィール`)
};

const zh_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人资料`)
};

const es_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const pt_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const id_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const fr_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const tl_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const vi_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ`)
};

const ko_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필`)
};

const de_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const ru_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль`)
};

const tr_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const it_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo`)
};

const pl_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const uk_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профіль`)
};

const hi_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल`)
};

const ar_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملف الشخصي`)
};

const ms_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const bn_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোফাইল`)
};

const zh_tw2_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人資料`)
};

const zh_hk2_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人資料`)
};

const ur_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پروفائل`)
};

const fa_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمایه`)
};

const sw_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasifu`)
};

const nl_profile_crumb = /** @type {(inputs: Profile_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Profile_CrumbInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const profile_crumb = /** @type {((inputs?: Profile_CrumbInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_CrumbInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_profile_crumb(inputs)
	if (locale === "ja") return ja_profile_crumb(inputs)
	if (locale === "zh") return zh_profile_crumb(inputs)
	if (locale === "es") return es_profile_crumb(inputs)
	if (locale === "pt") return pt_profile_crumb(inputs)
	if (locale === "id") return id_profile_crumb(inputs)
	if (locale === "fr") return fr_profile_crumb(inputs)
	if (locale === "tl") return tl_profile_crumb(inputs)
	if (locale === "vi") return vi_profile_crumb(inputs)
	if (locale === "ko") return ko_profile_crumb(inputs)
	if (locale === "de") return de_profile_crumb(inputs)
	if (locale === "ru") return ru_profile_crumb(inputs)
	if (locale === "tr") return tr_profile_crumb(inputs)
	if (locale === "it") return it_profile_crumb(inputs)
	if (locale === "pl") return pl_profile_crumb(inputs)
	if (locale === "uk") return uk_profile_crumb(inputs)
	if (locale === "hi") return hi_profile_crumb(inputs)
	if (locale === "ar") return ar_profile_crumb(inputs)
	if (locale === "ms") return ms_profile_crumb(inputs)
	if (locale === "bn") return bn_profile_crumb(inputs)
	if (locale === "zh-TW") return zh_tw2_profile_crumb(inputs)
	if (locale === "zh-HK") return zh_hk2_profile_crumb(inputs)
	if (locale === "ur") return ur_profile_crumb(inputs)
	if (locale === "fa") return fa_profile_crumb(inputs)
	if (locale === "sw") return sw_profile_crumb(inputs)
	if (locale === "nl") return nl_profile_crumb(inputs)
	return en_profile_crumb(inputs)
});